var moment = require('moment');
export default function () {
  return {
    interacciones_por_hora: "",
    porcentaje_interacciones: "",
    promedios: "",
    conversaciones: "",
    fecha_inicio:moment(new Date()).format('D-M-YYYY'),
    fecha_final:moment(new Date()).format('D-M-YYYY')
  }
}
